module.exports = __webpack_public_path__ + "media/images/xpass/markers/inactive-selected/akt-3c0878fa24702b0d4eafe70741982375.png";